import React from "react";
import { SideDrawer } from "@/components/partial/SideDrawer/SideDrawer";
import Reservations, {
  ReservationProps
} from "@/components/dashboard/Reservations";


type Props = ReservationProps & {
  embedded?: boolean;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  zIndex?: number;
  onShowingAnotherModal?: (showing: boolean) => void;
  innerClassName?: string;
};

export default function ReservationsMobilePanel({
  embedded = false,
  open,
  setOpen,
  zIndex,
  onShowingAnotherModal,
  innerClassName,
  ...reservationProps
}: Props) {
  return (
    <SideDrawer
      open={open}
      setOpen={setOpen}
      title={""}
      zIndex={zIndex}
      innerClassName={innerClassName}
    >
      <div className="-mx-4 -my-6 relative flex-1">
        <Reservations
          onShowingAnotherModal={onShowingAnotherModal}
          embedded={embedded}
          setOpenReservationsPanel={setOpen}
          {...reservationProps}
        />
      </div>
    </SideDrawer>
  );
}
